export const CartRemoveItemSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="fill-blue-950"
  >
    <path d="M9.16797 3.25H9.625H14.125H14.5469L14.8281 3.63672L16.4453 6.0625H16.9023H18.625H19.75V7.75H18.4844L17.5 21.25H6.25L5.23047 7.75H4V6.0625H5.125H6.8125H7.26953L8.92188 3.63672L9.16797 3.25ZM9.30859 6.0625H14.4062L13.668 4.9375H10.0469L9.30859 6.0625ZM6.91797 7.75L7.79688 19.5625H15.918L16.7969 7.75H6.91797Z" />
  </svg>
);
